import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import Header from "../../components/Header";
import { getHospitalsAndHealthCentersById } from "./../../ApiConfig.jsx";

function ViewHospitalsAndHealthCenters() {
  const { id } = useParams();
  const [itemDetails, setItemDetails] = useState({});
  const fetchData = async (id) => {
    try {
      const data = await getHospitalsAndHealthCentersById(id);
      if (data.status) {
        console.log(data.result);
        setItemDetails({
          Name: data.result.name,
          Address: data.result.address,
          Phone: data.result.phone,
          Email: data.result.email,
          Type: data.result.type==="public" ? "Public" : "Private",
          "Contact person": data.result.contactPerson,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title={`View Hospital ${id}`} subtitle="" />
      <Box ml={"40px"}>
        <Grid container spacing={2}>
          {Object.entries(itemDetails).map(([field, value]) => (
            <React.Fragment key={field}>
              <Grid item xs={3}>
                <Typography variant="h5" component="span" fontWeight="bold">
                  {field}:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>{value}</Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default ViewHospitalsAndHealthCenters;
